"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const areValuesStrictEqual_1 = __importDefault(require("../shared/areValuesStrictEqual"));
const getValueByPathFromUnknown_1 = __importDefault(require("../shared/getValueByPathFromUnknown"));
const areDbRoutesEqual_1 = __importDefault(require("./areDbRoutesEqual"));
const cleanDatabasePath_1 = __importDefault(require("./cleanDatabasePath"));
const isDbRouteFiltered_1 = __importDefault(require("./isDbRouteFiltered"));
const isPathChildrenOf_1 = __importDefault(require("./isPathChildrenOf"));
const updateDatabaseCache = ({ currentCacheData, currentTimeInMillis, data, route, }) => {
    const newRecordRoute = Object.assign(Object.assign({}, route), { path: (0, cleanDatabasePath_1.default)(route.path) });
    const newRecord = {
        data,
        lastUpdateTimestamp: currentTimeInMillis,
        route: newRecordRoute,
    };
    const isNewRouteFiltered = (0, isDbRouteFiltered_1.default)(newRecordRoute);
    const isNewRecordChild = (0, isPathChildrenOf_1.default)(newRecordRoute.path);
    const filteredCache = [];
    currentCacheData.forEach((originalRecord) => {
        let record = originalRecord;
        if (!isNewRouteFiltered && isNewRecordChild(record.route.path)) {
            if ((0, isDbRouteFiltered_1.default)(record.route)) {
                return;
            }
            const subPath = (0, cleanDatabasePath_1.default)(record.route.path.replace(new RegExp(`^${newRecordRoute.path}`), ''));
            if (subPath) {
                const updatedData = (0, getValueByPathFromUnknown_1.default)(data, subPath.split('/'));
                record = Object.assign(Object.assign({}, record), { data: updatedData, lastUpdateTimestamp: currentTimeInMillis });
            }
        }
        filteredCache.push(record);
    });
    const matchedIndex = filteredCache
        .findIndex((record) => (0, areDbRoutesEqual_1.default)(record.route, route));
    if (matchedIndex !== -1) {
        const originalData = filteredCache[matchedIndex].data;
        if ((0, areValuesStrictEqual_1.default)(originalData)(newRecord.data)) {
            newRecord.data = originalData;
        }
        filteredCache[matchedIndex] = newRecord;
        return filteredCache;
    }
    return [
        ...filteredCache,
        newRecord,
    ];
};
exports.default = updateDatabaseCache;
